App.controller('LifeWithPaymentsVariantCtrl', ['$scope', '$rootScope', '$sce', '$state', 'Configurator', '$http', '$stateParams', '$mdDialog', 'Config', 'fieldsService', '$filter', '$timeout', 'lifeInsuranceWithPaymentsService', 'popUpService', 'userInvitationService', 'variantsMatrixService', function ($scope, $rootScope, $sce, $state, Configurator, $http, $stateParams, $mdDialog, Config, fieldsService, $filter, $timeout, lifeInsuranceWithPaymentsService, popUpService, userInvitationService, variantsMatrixService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'life';
    $scope.$emit('page', $scope.page);

    $scope.step = '';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.life.start';
    $scope.$emit('link', $scope.link);

    popUpService.showPopUp({
        ev: '',
        head: '',
        content: 'Uruchomiliśmy nową wersję systemu do obsługi kontynuacji ubezpieczenia.<br/>' +
            'Od teraz możesz przystąpić do ubezpieczenia pod adresem: <a href="https://kontynuacja.xilium.pl">https://kontynuacja.xilium.pl</a>',
        text: 'Zamknij',
        target: '',
        tpl: 'info-big',
        clickOutsideToClose: false,
    });

    $scope.invitationToken = '';
    let hasActiveDeclaration = !!$rootScope.__logged;
    let hasReadyDeclaration = !!$rootScope.__logged;
    let hasEnteredDeclaration = !!$rootScope.__logged;

    if (lifeInsuranceWithPaymentsService.isPzu()) {
        $scope.announcement = "Małżonek i pełnoletnie dzieci przystępują, rejestrując własne Konto Użytkownika.";
    } else {
        $scope.announcement = "";
    }
    $scope.groupwidth = [];
    $scope.singleLength = [];
    $scope.allLength = 0;
    $scope.singleItemGroupWeight = 1;
    $scope.availableLifePackages = [];
    $scope.groupColors = ['', 'beige', 'powderblue', 'aliceblue'];
    $scope.isLifePackageDisabled = function (id) {
        return _.find($scope.availableLifePackages, function (e) {
            return e === id;
        }) === undefined;
    };

    lifeInsuranceWithPaymentsService.getAllPackages().then(function (data) {
        $scope.lifePackages = data.data.group;
        $scope.visibleLifePackages = [];
        let mandatoryPackagesPrice = 0;
        for (let i = 0; i < $scope.lifePackages.length; i++) {
            if ($scope.lifePackages[i].mandatory) {
                for (let j = 0; j < $scope.lifePackages[i].item.length; j++) {
                    mandatoryPackagesPrice += $scope.lifePackages[i].item[j].price;
                }
            } else {
                $scope.visibleLifePackages.push(angular.copy($scope.lifePackages[i]));
            }
        }
        for (let i = 0; i < $scope.visibleLifePackages.length; i++) {
            for (let j = 0; j < $scope.visibleLifePackages[i].item.length; j++) {
                $scope.visibleLifePackages[i].item[j].price += mandatoryPackagesPrice;
            }
        }
        $scope.availableLifePackages = _.map(_.flatMap($scope.lifePackages, function (group) {
            return group.item;
        }), function (item) {
            return item.id;
        });

        variantsMatrixService.determineSingleAndAllLength($scope);
        variantsMatrixService.determineGroupwidth($scope);

        if ($rootScope.__logged) {
            lifeInsuranceWithPaymentsService.available().then(function (data) {
                $scope.availableLifePackages = data.data.availableLifePackages;
                hasActiveDeclaration = data.data.hasActiveDeclaration;
                hasReadyDeclaration = data.data.hasReadyDeclaration;
                hasEnteredDeclaration = data.data.hasEnteredDeclaration;
                if (!$scope.canCompleteDeclaration()) {
                    if (lifeInsuranceWithPaymentsService.isPzu() && ! hasReadyDeclaration) {
                        popUpService.showPopUp({
                            ev: '',
                            head: '',
                            content: 'Aby wprowadzić zmiany w deklaracji należy przejść na stronę Moje dokumenty i kliknąć Wprowadź zmiany.',
                            text: 'Moje dokumenty',
                            target: 'root.life.list',
                            tpl: 'info-big',
                            clickOutsideToClose: false,
                            secondButton: {
                                text: 'Zamknij',
                                target: '',
                            }
                        });
                    } else if (lifeInsuranceWithPaymentsService.isUnum()) {
                        popUpService.showPopUpBigInfo('', '', 'Aby zmienić dane lub zaprosić członków rodziny, wejdź w zakładkę Moje deklaracje.');
                    }
                }
            });
        } else if ($scope.stateParams.invitationToken !== '') {
            userInvitationService.getInvitation($scope.stateParams.invitationToken).then(function (success) {
                if (success.status === 200 && success.data && success.data.status === 'PENDING') {
                    $scope.invitationToken = $scope.stateParams.invitationToken;
                    lifeInsuranceWithPaymentsService.availableInvitation($scope.invitationToken).then(function (data) {
                        $scope.availableLifePackages = data.data.availableLifePackages;
                    });
                    popUpService.showPopUpBigInfo('', '', 'Członkowie rodzin mogą przystąpić wyłącznie do Wariantu I. Dodatkowo istnieje możliwość nabycia pakietu U Chroni Onkologicznie i/lub U Chroni Serce pod warunkiem, że Ubezpieczony Główny również nabył taki sam pakiet.', '', '');
                } else {
                    popUpService.showPopUpBigInfo('', '', 'Link jest już nieaktywny.', 'Ok', 'root.dashboard');
                }
            });
        }
    });

    $scope.allowedToSaveDeclaration = {
        result: true,
    };
    if ($rootScope.__logged) {
        lifeInsuranceWithPaymentsService.isAllowedToSaveDeclaration().then(function (data) {
            $scope.allowedToSaveDeclaration = data.data;
        });
    }

    if ($scope.stateParams.choose && $scope.stateParams.prices) {
        $scope.choose = $scope.stateParams.choose;
        $scope.prices = $scope.stateParams.prices;
        $scope.persons = $scope.stateParams.persons;
        $scope.summary = $scope.stateParams.summary;
    } else {
        $scope.choose = [{}]; // TODO-MZ
        $scope.prices = [{}];
        $scope.summary = 0;
    }
    if (!$scope.persons) {
        $scope.persons = [{
            "type": "USER",
            "name": "Ubezpieczony"
        }];
    }

    lifeInsuranceWithPaymentsService.getInsuranceCoverage().then(function (data) {
        $scope.fields = data.data.fields;
        for (let i = 0; i < $scope.fields.length; i++) {
            $scope.fields[i].name = $sce.trustAsHtml($scope.fields[i].name);
        }
    });


    $scope.list = function () {
        $state.go('root.life.list');
    };

    $scope.next = function () {
        if (!$scope.canCompleteDeclaration()) {
            return;
        }
        if (!$scope.allowedToSaveDeclaration.result) {
            popUpService.showPopUpBigInfo('', '', 'Nie jesteś uprawniony do przystąpienia do programu kontynuacji.<br/>' +
                'W przypadku pytań zapraszamy do kontaktu z infolinią: 58 355 03 03');
            return;
        }
        if (!Object.keys($scope.choose[0]).length) {
            popUpService.showPopUpBigInfo('', 'Dokonaj wyboru wariantu ubezpieczenia', 'Aby kontynuować zaznacz minimum jeden wariant ubezpieczenia Życie i Zdrowie.');
            return 0;
        }

        if (!$rootScope.__logged) {
            let location = 'root.login';
            if ($scope.invitationToken !== '') {
                location = 'root.register';
            }
            $state.go(location, {
                persons: $scope.persons,
                choose: $scope.choose,
                prices: $scope.prices,
                summary: $scope.summary,
                invitationToken: $scope.invitationToken,
                redirectToThirdStep: true,
                redirectLocation: 'root.life.form'
            });
            return;
        }

        $state.go('root.life.form', {
            persons: $scope.persons,
            choose: $scope.choose,
            prices: $scope.prices,
            summary: $scope.summary,
            hasEnteredDeclaration: hasEnteredDeclaration,
            hasActiveDeclaration: hasActiveDeclaration
        });
    };

    $scope.declineInvitation = function () {
        if ($scope.invitationToken) {
            userInvitationService.declineInvitation($scope.invitationToken).then(
                function (success) {
                    if (success.status === 200) {
                        popUpService.showPopUpBigInfo('', 'Informacja', 'Dziękujemy za informację. Rezygnacja z oferty została oznaczona w naszym systemie.', 'Ok', 'root.dashboard');
                    }
                },
                function () {
                    popUpService.showPopUpBigInfo('', 'Błąd', 'Rezygnacja z oferty się nie powiodła. Spróbuj ponownie.');
                }
            );
        }
    };

    $scope.canCompleteDeclaration = function () {
        if (lifeInsuranceWithPaymentsService.isPzu()) {
            return $scope.stateParams.isChange || (!hasActiveDeclaration && !hasReadyDeclaration);
        } else {
            return !hasActiveDeclaration && !hasReadyDeclaration;
        }
    };
}]);
